import { Typography, useTheme } from "@mui/material";
import FlexBetween from "components/FlexBetween";
import WidgetWrapper from "components/WidgetWrapper";

const AdvertWidget = () => {
  const { palette } = useTheme();
  const dark = palette.neutral.dark;
  const main = palette.neutral.main;
  const medium = palette.neutral.medium;

  return (
    <WidgetWrapper>
      <FlexBetween>
        <Typography color={dark} variant="h5" fontWeight="500">
          Sponsored
        </Typography>
        <Typography color={medium}>Create Ad</Typography>
      </FlexBetween>
      <img
        width="100%"
        height="auto"
        alt="advert"
        src="http://localhost:3001/assets/info4.jpg"
        style={{ borderRadius: "0.75rem", margin: "0.75rem 0" }}
      />
      <FlexBetween>
        <Typography color={main}>Jujutsu Kaisen Season 2</Typography>
        <Typography color={medium}>netflix.com</Typography>
      </FlexBetween>
      <Typography color={medium} m="0.5rem 0">
      "Highly recommend you to watch this. Everything is nearly perfect; the plot, characters, action scenes, EVERYTHING. It's not an anime that will make you regret it. WHAT ARE YOU WAITING FOR!!"
      </Typography>
    </WidgetWrapper>
  );
};

export default AdvertWidget;